import React, { useState, useRef } from 'react';
import { RiFileEditLine as EditLine, RiFileDownloadLine as DownloadLine } from 'react-icons/ri';
import {
  DropdownText, DropdownItem, Wrapper, Dropdown
} from 'Screens/Contextualization/Manage/components/CreateActions/styled';
import { Button, Plus } from './styled';
import { useDispatch } from 'react-redux';
import { showCreateEditModal, showImportModal } from 'store/Credentials/actions';
import useClickOutside from 'Hooks/useClickOutside';

const AddCredentialButton = () => {
  const dispatch = useDispatch();
  const dropdownRef = useRef();
  const [showDropdown, setShowDropdown] = useState(false);

  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleShow = () => {
    dispatch(showCreateEditModal(true, {}));
    setShowDropdown(false);
  };

  const handleClickImport = () => {
    dispatch(showImportModal(true));
    setShowDropdown(false);
  };

  return (
    <Wrapper ref={ dropdownRef }>
      <Button onClick={ handleDropdown } data-tour="Add Vulnerability">
        <Plus />
        <DropdownText>Add Credentials</DropdownText>
      </Button>
      {showDropdown && (
      <Dropdown>
        <DropdownItem onClick={ handleShow } role="button" aria-label="Manual Creation" type="button">
          <EditLine size="1.3em" color="#5a6b7d" />
          Manual Creation
        </DropdownItem>
        <DropdownItem onClick={ handleClickImport } role="button" aria-label="Import from File" type="button">
          <DownloadLine size="1.3em" color="#5a6b7d" />
          Import from File
        </DropdownItem>
      </Dropdown>
      )}

      {/* { showModalImport && <ImportFileCreationModal handleClose={ handleCloseImportFromFile } entity={ entity } /> }
      { showModalCreation && <ManualCreationModal handleClose={ handleClose } entity={ entity } /> } */}
    </Wrapper>
  );
};

export default AddCredentialButton;
